export default __webpack_public_path__ + "static/media/404.1961a781.png";